import { gql } from 'graphql-tag';

import { CatchFragments } from './CatchType';
import { ImageFragments } from './ImageType';
import { PostFragments } from './PostType';
import { UserFragments } from './UserType';

/* TODO:
    - investigate if we need isPremium field on user once we remove the
      old species cards.
*/

// This is the complete set of fields we use for the catch viewer
// and is used across the site by all pages where we show catches

const CatchPostForPostsViewerFragment = gql`
  fragment CatchPostForPostsViewer on Post {
    ...PostId
    catch {
      ...CatchId
      ...CatchFishingWaterName
      ...CatchSpeciesName
      caughtAtGmt
      weight
      length
    }
    comments {
      totalCount
    }
    createdAt
    displayProductUnits {
      totalCount
    }
    ...PostDisplayEntities
    ...PostProductUnits
    ...PostVideoFields
    images(first: 10, croppingStrategy: SMART, height: 400, width: 400) {
      totalCount
      edges {
        node {
          ...ImageFields
        }
      }
    }
    likedByCurrentUser
    likesCount
    text {
      text
    }
    user {
      ...UserId
      ...UserAvatar
      nickname
    }
  }
  ${PostFragments.id}
  ${CatchFragments.id}
  ${CatchFragments.fishingWaterName}
  ${CatchFragments.speciesName}
  ${PostFragments.productUnits}
  ${PostFragments.displayEntities}
  ${PostFragments.videoFields}
  ${ImageFragments.imageFields}
  ${UserFragments.id}
  ${UserFragments.avatar}
`;

export const CatchFieldsForPostsViewer = gql`
  fragment CatchFieldsForPostsViewer on Catch {
    ...CatchId
    post {
      ...CatchPostForPostsViewer
    }
  }
  ${CatchFragments.id}
  ${CatchPostForPostsViewerFragment}
`;
